module.exports = __webpack_public_path__ + "static/media/J-Spades.316b7a9f.svg";